import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PlannerOwnerForm from '../containers/PlannerOwnerFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlannerOwnerAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PlannerOwnerAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('planner_owner_route_add')} />
          <PlannerOwnerForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerOwnerAddScreen;

Logger.log('silly', `PlannerOwnerAddScreen loaded.`);
